// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Button, type ButtonProps } from 'Components/frameworks/button/Button.jsx';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';

export type Props = {
  button?: ?ButtonProps,
  className?: string,
  icon?: IconName,
  link?: {
    label?: string,
    url?: string,
  },
  status?: 'success' | 'error' | 'neutral',
  text?: string,
  title?: string,
};

function getDefaultIcon(status) {
  return status === 'success' ? ICONS.CONFIRMATION : ICONS.WARNING;
}

export function Confirmation(props: Props) {
  const { button = {}, className, icon, link, status, text, title } = props;

  if (!status || !title) {
    return null;
  }

  const colors = {
    error: COLORS.RED,
    neutral: COLORS.BLUE,
    success: COLORS.EMERALD,
  };

  const iconName = icon ? icon : getDefaultIcon(status);

  return (
    <div className={classnames(className, 'flex items-start sm:items-center sm:px-8')}>
      <div
        className={classnames(
          'leading-none rtl:mr-4 rtl:sm:mr-8 text-sm sm:text-xl',
          `text-${colors[status]}`,
        )}
      >
        <Icon name={iconName} width="4em" />
      </div>
      <div className="flex-auto">
        <div className={classnames('font-bold text-md sm:text-xl', `text-${colors[status]}`)}>
          {title}
        </div>
        <Text text={text} />
        <div className="flex flex-col-reverse	sm:flex-row sm:items-start">
          <TextLink {...link} className="mt-3 sm:rtl:mr-auto" />
          {button &&
            button.children && (
              <Button {...button} className="my-3">
                {button.children}
              </Button>
            )}
        </div>
      </div>
    </div>
  );
}
